import React from 'react';
import { ChevronRight } from 'styled-icons/feather/ChevronRight';

function NextIcon(props) {
  return (
    <ChevronRight {...props} className={'icon'} />
  );
}

export default NextIcon;
